<template>
  <div :style="style1">
    <button @click="buttonfs" :style="style8">字</button>
    <!--div style="margin-bottom:5px;margin-top:5px"><button @click="buttonf1" v-show="kaishibuttonvisiable">上一题</button><button @click="buttonf2" v-show="xiangxiabuttonvisiable">下一题</button><button @click="buttonf3">提交</button></div>-->
    <div style="margin-bottom:3px;margin-top:3px;"><button @click="buttonf1" :style="viskaishi">上一题</button><button @click="buttonf2" :style="visxia">下一题</button><button @click="buttonf3" :style="tijiaovisiable">提交</button></div>
    <dati style="margin-left:3%;margin-right:2%" :datiobject="allobjlist.objlist[allindex]" :allindex="allindex" :fontsize="fontsize"></dati>
    <!--
    <input type="text" ref="input_text"/>
    <button @click="buttonf1">dfg</button>
    <li v-for="(data,index) in list" :key="index">
    </li>
    -->
   <router-view></router-view>
  </div>
</template>

<script>
import global from './components/global'

import dati from './components/dati.vue'

export default {
  components: { dati }, // 此为局部组件写法
  data () {
    return {
      allobjlist: global.allobjlist,
      allindex: global.allindex,
      list: global.list,
      answerlist: global.answerlist,
      yonghuming: this.$getyonghuming(),
      fontsize: global.fontsize
    }
  },
  computed: {
    kaishibuttonvisiable: function () {
      let kaishibuttonvisiable = true
      if (this.allindex === 0)kaishibuttonvisiable = false
      return kaishibuttonvisiable
    },
    xiangxiabuttonvisiable: function () { // v-show 隐藏 是display:'none'v-if 隐藏是 visibility:hidden;
      let xiangxiabuttonvisiable = true
      if (this.allindex === this.allobjlist.datishu - 1)xiangxiabuttonvisiable = false
      return xiangxiabuttonvisiable
    },
    viskaishi: function () {
      // let kaishibuttonvisiable = true
      let viskaishi = 'visibility:visible'
      if (this.allindex === 0) { // kaishibuttonvisiable = false;
        viskaishi = 'visibility:hidden'
      }
      return viskaishi
    },
    style8: function () {
      // let kaishibuttonvisiable = true
      const v = 'visibility:visible;float:right;width:2em'
      return v
    },
    visxia: function () {
      // let xiangxiabuttonvisiable = true
      let visxia = 'visibility:visible'
      if (this.allindex === this.allobjlist.datishu - 1) {
        // xiangxiabuttonvisiable = false;
        visxia = 'visibility:hidden'
      }
      return visxia
    },
    style1: function () {
      const style = 'font-size:' + (this.fontsize) + 'px'
      return style
    },
    tijiaovisiable: function () { // v-show 隐藏 是display:'none'v-if 隐藏是 visibility:hidden;
      let tijiaovisiable = 'visibility:hidden'
      // if (this.allindex === this.allobjlist.datishu - 1)tijiaovisiable = 'visibility:visible'
      if (this.allindex === this.allobjlist.datishu - 1)tijiaovisiable = 'visibility:hidden'
      return tijiaovisiable
    }
  },
  methods: {
    buttonf1 () {
      // global.allobjlist.objlist[0].kaoshenganswer[2][3] = 'ok'
      // console.log(this.allobjlist)
      if (this.allindex > 0) { this.allindex = this.allindex - 1 }
    },
    buttonf2 () {
      if (this.allindex < this.allobjlist.datishu - 1) { this.allindex = this.allindex + 1 }
    },
    buttonfs () {
      if (this.fontsize === 55) { this.fontsize = 40; this.$set(global, 'fontsize', 40) } else if (this.fontsize === 40) { this.fontsize = 20; this.$set(global, 'fontsize', 20) } else if (this.fontsize === 20) { this.fontsize = 15; this.$set(global, 'fontsize', 15) } else if (this.fontsize === 15) { this.fontsize = 55; this.$set(global, 'fontsize', 55) }
      this.$forceUpdate()
    },
    buttonf3 () { //
      const datishu = this.allobjlist.datishu
      // const answerlist = this.allobjlist.answerlist
      // const list = this.allobjlist.list
      const objlist = this.allobjlist.objlist
      let tihao = 1 // 从一开始
      const daan = []
      for (let i = 0; i < datishu; i++) { // 遍历各个大题
        const curlistobj = objlist[i]

        // const data = curlistobj.data
        const kaoshenganswer = curlistobj.kaoshenganswer
        const xiaotinumber = curlistobj.xiaotinumber
        const answerlist = curlistobj.answerlist

        for (let j = 0; j < xiaotinumber.length; j++) { // 去掉填空了
          if (xiaotinumber[j] > 0) { for (let k = 0; k < xiaotinumber[j]; k++) { daan.push({ tihao: tihao++, key: kaoshenganswer[j][k].split(' ').join(''), rightkey: answerlist[j][k] }) } }
        }
      }
      const l = daan.length
      let temptrueti = 0
      const dangeksdaan = []
      const zqdangeksdaan = []
      for (let t = 0; t < l; t++) { dangeksdaan.push(daan[t].key); zqdangeksdaan.push(daan[t].rightkey); if (daan[t].key === daan[t].rightkey)temptrueti++ }
      const score = Math.round(temptrueti * 100 / l)
      const ksdaanstr = dangeksdaan.join()
      const zqdaanstr = zqdangeksdaan.join()
      console.log(score + ksdaanstr + zqdaanstr)
      // const host = window.location.host
      // const url = 'http://' + host + '/dengfen'
      // const data = { yonghuming: 'nyzx0234', paper: 9, score: score, ksdaanstr: ksdaanstr, zqdaanstr: zqdaanstr }
      // const data = { yonghuming: 'nyzx0234', paper: 9, score: 22 }
      // this.$axios.post(url, data)
      // .then(data => { alert(data.data) })
    }
    // sendclickandtime () {
    //   const t = new Date().getTime() / 60000
    //   const time = Math.floor(t) - this.$jiankongdata.timestart
    //   const countclick = this.$jiankongdata.countclick[0]
    //   const host = window.location.host
    //   const url = 'http://' + host + '/dengfen'
    //   // const data = { yonghuming: 'nyzx0234', paper: 9, score: score, ksdaanstr: ksdaanstr, zqdaanstr: zqdaanstr }
    //   const data = { yonghuming: this.yonghuming, paper: time / 10, score: countclick }
    //   if (countclick > 8) {
    //     this.$axios.post(url, data)
    //       .then(data => {
    //         alert('你好，已经刷题十分钟了，老师为你加油，记得多动动笔！！！')
    //         this.$jiankongdata.countclick.pop()
    //         this.$jiankongdata.countclick.push(0)
    //       })
    //   }
    // }
  },
  watch: {
    fontsize: function () {
    // alert(global.fontsize)
      this.$forceUpdate()
    }
  },
  mounted: function () {
    // console.log('mounted：此时，组件已经出现在页面中，数据、真实dom都已经处理好了,事件都已经挂载好了')
    // console.log(document.getElementsByClassName("myp")[0])
    // console.log('可以在这里操作真实dom等事情...')
    // window.setInterval(() => { setTimeout(() => { this.sendclickandtime() }, 0) }, 630000)
    //    this.$options.timer = setInterval(function () {
    //        console.log('setInterval')
    //         this.msg+='!'
    //    }.bind(this),500)
  }
}
</script>
<style>
button{
  width: 20%;
  height: 2em;
  margin-left: 2%;
  margin-right: 2%;
}

</style>
